import { render, staticRenderFns } from "./PublicationWidget.vue?vue&type=template&id=5b4f2c2f&scoped=true&"
import script from "./PublicationWidget.vue?vue&type=script&lang=js&"
export * from "./PublicationWidget.vue?vue&type=script&lang=js&"
import style0 from "./PublicationWidget.vue?vue&type=style&index=0&id=5b4f2c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4f2c2f",
  null
  
)

export default component.exports